import Akten from './container'
export { Akten }
export default Akten